// import * as pdfMake from 'pdfmake/build/pdfmake';
// import * as pdfFonts from 'pdfmake/build/vfs_fonts';
// import api from '../lib/api.ts';

// // Initialize pdfMake with fonts
// (pdfMake as any).vfs = (pdfFonts as any).pdfMake.vfs;

// // Interface for vehicle data
// interface VehicleData {
//   id: number;
//   name?: string; // Full vehicle name like "2011 DODGE Charger"
//   lotNumber?: string;
//   lot?: string;
//   Make?: string | { name: string; id?: number };
//   make?: string | { name: string; id?: number };
//   MakeModel?: string | { name: string; id?: number; make?: { name: string; id?: number } };
//   model?: string | { name: string; id?: number };
//   variant?: string | { name: string; id?: number };
//   variantName?: string;
//   year?: number;
//   vinNumber?: string;
//   vin?: string;
//   marketValue?: number;
//   marketPrice?: number;
//   startingBid?: number;
//   startingPrice?: number;
//   reservedPrice?: number; // Note: reservedPrice
//   reservePrice?: number;
//   mileage?: number;
//   engine?: string | { name: string; id?: number };
//   engineType?: string;
//   cylinder?: number | { name: string; id?: number };
//   cylinders?: number;
//   fuelType?: string | { name: string; id?: number };
//   fuelTypeName?: string;
//   TransmissionType?: string | { name: string; id?: number } | null;
//   transmissionType?: string | { name: string; id?: number };
//   transmission?: string | { name: string; id?: number };
//   BodyType?: string | { name: string; id?: number };
//   bodyType?: string | { name: string; id?: number };
//   bodyTypeName?: string;
//   primaryDamageType?: string | { name: string; id?: number };
//   primaryDamage?: string | { name: string; id?: number };
//   secondaryDamageType?: string | { name: string; id?: number } | null;
//   secondaryDamage?: string | { name: string; id?: number };
//   InteriorColor?: {
//     name: string;
//     color: string;
//   };
//   interiorColor?: string | { name: string; id?: number };
//   interiorColorName?: string;
//   ExteriorColor?: {
//     name: string;
//     color: string;
//   };
//   exteriorColor?: string | { name: string; id?: number };
//   exteriorColorName?: string;
//   Highlight?: {
//     name: string;
//     textColor: string;
//     bgColor: string;
//   };
//   images?: Array<{
//     imageUrl: string;
//     orderNo: number;
//     [key: string]: any;
//   }> | string[];
// }

// // Interface for auction data
// interface AuctionData {
//   id: number;
//   name: string;
//   startDate: string;
//   auctionLanes: Array<{
//     id: number;
//     lane: {
//       name: string;
//     };
//     auctionLaneVehicles: VehicleData[];
//   }>;
// }

// // Fetch vehicles for a specific auction lane
// export const fetchVehiclesForLane = async (auctionId: number, laneId: number): Promise<VehicleData[]> => {
//   try {
//     // Try the bidding vehicle list endpoint first
//     const response = await api.get(`/bidding/vehicle-list/${laneId}`);

//     // Handle different response structures
//     if (response.data && Array.isArray(response.data)) {
//       return response.data;
//     } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
//       return response.data.data;
//     } else if (response.data && response.data.success && response.data.data) {
//       return response.data.data;
//     } else {
//       console.warn('Unexpected response structure:', response.data);
//       return [];
//     }
//   } catch (error) {
//     console.error('Error fetching vehicles for lane:', error);
//     console.error('Error response:', error.response);
//     console.error('Error status:', error.response?.status);
//     console.error('Error data:', error.response?.data);
//     throw error;
//   }
// };

// // Format price for display
// const formatPrice = (price: number | string): string => {
//   if (!price) return '';
//   const numPrice = typeof price === 'string' ? parseFloat(price) : price;
//   return `AED ${numPrice.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
// };

// // Helper function to safely extract string values from objects or strings
// const getStringValue = (value: any): string => {
//   if (!value) return '';
//   if (typeof value === 'string') return value;
//   if (typeof value === 'object' && value.name) return value.name;
//   if (typeof value === 'number') return value.toString();
//   return '';
// };

// // Fetch image as base64 - improved for CORS handling
// const fetchImageAsBase64 = async (url: string): Promise<string | null> => {
//   try {
//     const cleanUrl = url.trim();
//     if (!cleanUrl || cleanUrl === 'undefined' || cleanUrl === 'null') {
//       return null;
//     }

//     // Try backend API proxy first (avoids CORS issues)
//     if (cleanUrl.startsWith('http://') || cleanUrl.startsWith('https://')) {
//       try {
//         const response = await api.get('/utils/fetch-image', {
//           params: { url: cleanUrl },
//           responseType: 'blob',
//           timeout: 30000,
//         });

//         if (response.data && response.data instanceof Blob) {
//           return await new Promise((resolve, reject) => {
//             const reader = new FileReader();
//             reader.onloadend = () => {
//               resolve(reader.result as string);
//             };
//             reader.onerror = (error) => {
//               reject(error);
//             };
//             reader.readAsDataURL(response.data);
//           });
//         }
//       } catch (apiError: any) {
//         console.warn('Backend image proxy failed, trying direct fetch:', apiError?.message || 'Unknown error');
//       }
//     }

//     // Fallback to direct fetch
//     const response = await fetch(cleanUrl, {
//       mode: "cors",
//       credentials: "omit",
//       headers: {
//         'Accept': 'image/*'
//       }
//     });

//     if (!response.ok) {
//       return null;
//     }

//     const blob = await response.blob();
//     return await new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         resolve(reader.result as string);
//       };
//       reader.onerror = (error) => {
//         reject(error);
//       };
//       reader.readAsDataURL(blob);
//     });
//   } catch (err) {
//     console.error('Error fetching image:', err);
//     return null;
//   }
// };

// // Load image and return base64 for pdfmake
// const loadImageForPDF = async (imageUrl: string): Promise<string | null> => {
//   try {
//     if (!imageUrl || imageUrl === 'undefined' || imageUrl === 'null') {
//       return null;
//     }

//     // If it's already a base64 data URL, return it
//     if (imageUrl.startsWith('data:image/')) {
//       return imageUrl;
//     }

//     // If it's a local path, try to load it
//     if (imageUrl.startsWith('/')) {
//       try {
//         const response = await fetch(imageUrl);
//         if (response.ok) {
//           const blob = await response.blob();
//           return await new Promise((resolve) => {
//             const reader = new FileReader();
//             reader.onloadend = () => resolve(reader.result as string);
//             reader.onerror = () => resolve(null);
//             reader.readAsDataURL(blob);
//           });
//         }
//       } catch (error) {
//         console.error('Error loading local image:', error);
//       }
//     }

//     // For external URLs, use fetchImageAsBase64
//     return await fetchImageAsBase64(imageUrl);
//   } catch (error) {
//     console.error('Error in loadImageForPDF:', error);
//     return null;
//   }
// };

// // Generate PDF for auction lane vehicles
// export const generateAuctionLanePDF = async (
//   auctionId: number,
//   laneId: number,
//   auctionName: string,
//   laneName: string,
//   auctionDate?: Date | string
// ): Promise<void> => {
//   try {
//     // Fetch vehicles data
//     const vehicles = await fetchVehiclesForLane(auctionId, laneId);

//     if (!vehicles || vehicles.length === 0) {
//       alert('No vehicles found for this auction lane');
//       return;
//     }

//     // Colors
//     const primaryColor = '#F15A29'; // Orange
//     const darkGray = '#3C3C3C';
//     const lightGray = '#C8C8C8';
//     const white = '#FFFFFF';
//     const black = '#000000';

//     // Format auction date
//     let auctionDateTimeText = '';
//     if (auctionDate) {
//       const date = new Date(auctionDate);
//       if (!isNaN(date.getTime())) {
//         const day = date.getDate();
//         const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
//         const year = date.getFullYear();
//         auctionDateTimeText = `(${day},${dayName} ${year})`;
//       }
//     }

//     // Load logo
//     let logoBase64: string | null = null;
//     try {
//       const awsLogoUrl = process.env.REACT_APP_AWS_LOGO_URL;
//       if (awsLogoUrl) {
//         logoBase64 = await loadImageForPDF(awsLogoUrl);
//       } else {
//         logoBase64 = await loadImageForPDF('/Group34322224.png');
//       }
//     } catch (error) {
//       console.error('Error loading logo:', error);
//     }

//     // Build document content
//     const docDefinition: any = {
//       pageSize: 'A4',
//       pageMargins: [5, 5, 5, 5],
//       defaultStyle: {
//         font: 'Roboto',
//         fontSize: 8,
//       },
//       header: function(currentPage: number, pageCount: number) {
//         return {
//           margin: [0, 0, 0, 0],
//           table: {
//             widths: ['*'],
//             body: [
//               [
//                 {
//                   stack: [
//                     // Logo row
//                     {
//                       image: logoBase64 || 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==',
//                       width: 40,
//                       height: 15,
//                       alignment: 'center',
//                       margin: [0, 2, 0, 2],
//                     },
//                     // Auction details row
//                     {
//                       columns: [
//                         {
//                           width: '*',
//                           stack: [
//                             {
//                               text: [
//                                 { text: 'Auction Name: ', color: '#C86432', bold: true },
//                                 { text: auctionName, color: black }
//                               ],
//                               fontSize: 8,
//                               margin: [2, 0, 0, 1]
//                             },
//                             {
//                               text: [
//                                 { text: 'Auction Lane: ', color: '#C86432', bold: true },
//                                 { text: laneName, color: black }
//                               ],
//                               fontSize: 8,
//                               margin: [2, 0, 0, 1]
//                             }
//                           ]
//                         },
//                         {
//                           width: '*',
//                           stack: [
//                             {
//                               text: [
//                                 { text: 'Location: ', color: '#C86432', bold: true },
//                                 { text: 'Khat Al Jazeera Cars Auction, Al Sajaa', color: black }
//                               ],
//                               fontSize: 8,
//                               alignment: 'right',
//                               margin: [0, 0, 2, 1]
//                             },
//                             {
//                               text: [
//                                 { text: 'Date/Time: ', color: '#C86432', bold: true },
//                                 { text: auctionDateTimeText, color: black }
//                               ],
//                               fontSize: 8,
//                               alignment: 'right',
//                               margin: [0, 0, 2, 1]
//                             }
//                           ]
//                         }
//                       ],
//                       margin: [0, 2, 0, 2]
//                     },
//                     // Orange separator line
//                     {
//                       canvas: [
//                         {
//                           type: 'line',
//                           x1: 0,
//                           y1: 0,
//                           x2: 595 - 10,
//                           y2: 0,
//                           lineWidth: 0.5,
//                           lineColor: primaryColor
//                         }
//                       ],
//                       margin: [0, 2, 0, 2]
//                     }
//                   ],
//                   fillColor: white,
//                   margin: [0, 0, 0, 0]
//                 }
//               ]
//             ]
//           },
//           layout: 'noBorders'
//         };
//       },
//       content: [
//         // Catalog title
//         {
//           text: `${laneName} Vehicle Catalog (${vehicles.length} Listings)`,
//           fontSize: 14,
//           bold: true,
//           color: darkGray,
//           margin: [0, 10, 0, 4]
//         },
//         // Orange separator
//         {
//           canvas: [
//             {
//               type: 'line',
//               x1: 0,
//               y1: 0,
//               x2: 585,
//               y2: 0,
//               lineWidth: 0.1,
//               lineColor: primaryColor
//             }
//           ],
//           margin: [0, 0, 0, 5]
//         },
//         // Table header
//         {
//           table: {
//             headerRows: 1,
//             widths: [10, 20, '*', 25, 30, 40, 40],
//             body: [
//               // Header row
//               [
//                 { text: 'RUN#', fillColor: darkGray, color: white, bold: true, fontSize: 8, alignment: 'left', margin: [2, 4, 2, 4] },
//                 { text: 'IMAGE', fillColor: darkGray, color: white, bold: true, fontSize: 8, alignment: 'center', margin: [2, 4, 2, 4] },
//                 { text: 'VEHICLE DETAILS', fillColor: darkGray, color: white, bold: true, fontSize: 8, alignment: 'left', margin: [2, 4, 2, 4] },
//                 { text: 'MILES', fillColor: darkGray, color: white, bold: true, fontSize: 8, alignment: 'right', margin: [2, 4, 2, 4] },
//                 { text: 'FUEL/CYL', fillColor: darkGray, color: white, bold: true, fontSize: 8, alignment: 'left', margin: [2, 4, 2, 4] },
//                 { text: 'MARKET VALUE', fillColor: darkGray, color: white, bold: true, fontSize: 8, alignment: 'right', margin: [2, 4, 2, 4] },
//                 { text: 'STARTING BID', fillColor: darkGray, color: white, bold: true, fontSize: 8, alignment: 'right', margin: [2, 4, 2, 4] }
//               ],
//               // Vehicle rows - will be populated below
//               ...(await Promise.all(vehicles.map(async (vehicle, index) => {
//                 // Get vehicle image
//                 let vehicleImageBase64: string | null = null;
//                 let firstImage = '';

//                 if (vehicle.images && vehicle.images.length > 0) {
//                   const firstImageData = vehicle.images[0];
//                   if (typeof firstImageData === 'string') {
//                     firstImage = firstImageData;
//                   } else if (firstImageData && firstImageData.imageUrl) {
//                     firstImage = firstImageData.imageUrl;
//                   }
//                 }

//                 if (firstImage) {
//                   vehicleImageBase64 = await loadImageForPDF(firstImage);
//                 }

//                 // If no image, use placeholder
//                 if (!vehicleImageBase64) {
//                   vehicleImageBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==';
//                 }

//                 // Get vehicle details
//                 const makeName = typeof vehicle.Make === 'string' ? vehicle.Make : vehicle.Make?.name || 
//                                 (typeof vehicle.make === 'string' ? vehicle.make : vehicle.make?.name) || 
//                                 (typeof vehicle.MakeModel === 'object' && vehicle.MakeModel?.make?.name) || '';
//                 const modelName = typeof vehicle.model === 'string' ? vehicle.model : vehicle.model?.name || 
//                                  (typeof vehicle.MakeModel === 'string' ? vehicle.MakeModel : vehicle.MakeModel?.name) || '';
//                 const vehicleName = vehicle.name || `${vehicle.year || ''} ${makeName} ${modelName}`.trim();
//                 const lotNumber = vehicle.lotNumber || vehicle.lot || '';
//                 const engineSize = (typeof vehicle.engine === 'string' ? vehicle.engine : vehicle.engine?.name) || 
//                                   vehicle.engineType || '';
//                 const highlightData = vehicle.Highlight;
//                 const highlightValue = highlightData?.name || '';
//                 const fuelType = (typeof vehicle.fuelType === 'string' ? vehicle.fuelType : vehicle.fuelType?.name) || 
//                                vehicle.fuelTypeName || '';
//                 const cylinders = vehicle.cylinders || 
//                                  (typeof vehicle.cylinder === 'number' ? vehicle.cylinder : vehicle.cylinder?.name) || '';
//                 const mileage = vehicle.mileage || 0;
//                 const startingBid = vehicle.startingBid || 0;
//                 const marketValue = vehicle.marketValue || vehicle.marketPrice || 0;

//                 return [
//                   // RUN#
//                   {
//                     text: `${index + 1}`,
//                     fillColor: white,
//                     color: black,
//                     bold: true,
//                     fontSize: 8,
//                     alignment: 'left',
//                     margin: [2, 6, 2, 6]
//                   },
//                   // IMAGE
//                   {
//                     image: vehicleImageBase64,
//                     width: 15,
//                     height: 12,
//                     fit: [15, 12],
//                     alignment: 'center',
//                     margin: [2, 3, 2, 3]
//                   },
//                   // VEHICLE DETAILS
//                   {
//                     stack: [
//                       {
//                         text: vehicleName,
//                         fontSize: 7,
//                         bold: true,
//                         color: black,
//                         margin: [0, 0, 0, 1]
//                       },
//                       lotNumber ? {
//                         text: `Lot ${lotNumber}`,
//                         fontSize: 6,
//                         color: black,
//                         margin: [0, 0, 0, 1]
//                       } : {},
//                       {
//                         text: `Eng: ${engineSize} | Highlights: ${highlightValue || '-'}`,
//                         fontSize: 6,
//                         color: black,
//                         margin: [0, 0, 0, 0]
//                       }
//                     ],
//                     fillColor: white,
//                     margin: [2, 3, 2, 3]
//                   },
//                   // MILES
//                   {
//                     text: mileage.toLocaleString(),
//                     fillColor: white,
//                     color: black,
//                     fontSize: 6,
//                     alignment: 'right',
//                     margin: [2, 6, 2, 6]
//                   },
//                   // FUEL/CYL
//                   {
//                     text: `${fuelType} / ${cylinders} Cyl`,
//                     fillColor: white,
//                     color: black,
//                     fontSize: 6,
//                     alignment: 'left',
//                     margin: [2, 6, 2, 6]
//                   },
//                   // MARKET VALUE
//                   {
//                     text: formatPrice(marketValue),
//                     fillColor: white,
//                     color: '#FF9800',
//                     fontSize: 7,
//                     bold: true,
//                     alignment: 'right',
//                     margin: [2, 6, 2, 6]
//                   },
//                   // STARTING BID
//                   {
//                     text: formatPrice(startingBid),
//                     fillColor: white,
//                     color: black,
//                     fontSize: 7,
//                     bold: true,
//                     alignment: 'right',
//                     margin: [2, 6, 2, 6]
//                   }
//                 ];
//               })))
//             ]
//           },
//           layout: {
//             hLineWidth: function(i: number, node: any) {
//               return 0;
//             },
//             vLineWidth: function(i: number, node: any) {
//               return 0;
//             },
//             paddingLeft: function(i: number, node: any) {
//               return 0;
//             },
//             paddingRight: function(i: number, node: any) {
//               return 0;
//             },
//             paddingTop: function(i: number, node: any) {
//               return 0;
//             },
//             paddingBottom: function(i: number, node: any) {
//               return 0;
//             }
//           }
//         }
//       ],
//       footer: function(currentPage: number, pageCount: number) {
//         return {
//           text: `Page ${currentPage} of ${pageCount}`,
//           fontSize: 8,
//           color: lightGray,
//           alignment: 'right',
//           margin: [0, 10, 20, 10]
//         };
//       }
//     };

//     // Generate filename
//     const fileName = `${auctionName.replace(/[^a-zA-Z0-9]/g, '_')}_${laneName.replace(/[^a-zA-Z0-9]/g, '_')}_Vehicles.pdf`;

//     // Create and download PDF
//     (pdfMake as any).createPdf(docDefinition).download(fileName);

//   } catch (error: any) {
//     console.error('Error generating PDF:', error);
//     console.error('Error details:', {
//       message: error.message,
//       stack: error.stack,
//       name: error.name
//     });
//     alert(`Failed to generate PDF: ${error.message || ''}. Please check the console for details.`);
//   }
// };

// // Alternative method using HTML to PDF conversion (if needed)
// export const generateAuctionLanePDFFromHTML = async (
//   auctionId: number,
//   laneId: number,
//   auctionName: string,
//   laneName: string,
//   auctionDate?: Date | string
// ): Promise<void> => {
//   try {
//     await generateAuctionLanePDF(auctionId, laneId, auctionName, laneName, auctionDate?.toString());
//   } catch (error) {
//     console.error('Error generating PDF from HTML:', error);
//     alert('Failed to generate PDF. Please try again.');
//   }
// };










import jsPDF from 'jspdf';
import api from '../lib/api.ts';

// Interface for vehicle data
interface VehicleData {
  id: number;
  name?: string; // Full vehicle name like "2011 DODGE Charger"
  lotNumber?: string;
  lot?: string;
  Make?: string | { name: string; id?: number };
  make?: string | { name: string; id?: number };
  MakeModel?: string | { name: string; id?: number; make?: { name: string; id?: number } };
  model?: string | { name: string; id?: number };
  variant?: string | { name: string; id?: number };
  variantName?: string;
  year?: number;
  vinNumber?: string;
  vin?: string;
  marketValue?: number;
  marketPrice?: number;
  startingBid?: number;
  startingPrice?: number;
  reservedPrice?: number; // Note: reservedPrice not reservePrice
  reservePrice?: number;
  mileage?: number;
  engine?: string | { name: string; id?: number };
  engineType?: string;
  cylinder?: number | { name: string; id?: number };
  cylinders?: number;
  fuelType?: string | { name: string; id?: number };
  fuelTypeName?: string;
  TransmissionType?: string | { name: string; id?: number } | null;
  transmissionType?: string | { name: string; id?: number };
  transmission?: string | { name: string; id?: number };
  BodyType?: string | { name: string; id?: number };
  bodyType?: string | { name: string; id?: number };
  bodyTypeName?: string;
  primaryDamageType?: string | { name: string; id?: number };
  primaryDamage?: string | { name: string; id?: number };
  secondaryDamageType?: string | { name: string; id?: number } | null;
  secondaryDamage?: string | { name: string; id?: number };
  InteriorColor?: {
    name: string;
    color: string;
  };
  interiorColor?: string | { name: string; id?: number };
  interiorColorName?: string;
  ExteriorColor?: {
    name: string;
    color: string;
  };
  exteriorColor?: string | { name: string; id?: number };
  exteriorColorName?: string;
  Highlight?: {
    name: string;
    textColor: string;
    bgColor: string;
  };
  images?: Array<{
    imageUrl: string;
    orderNo: number;
    [key: string]: any;
  }> | string[];
}

// Interface for auction data
interface AuctionData {
  id: number;
  name: string;
  startDate: string;
  auctionLanes: Array<{
    id: number;
    lane: {
      name: string;
    };
    auctionLaneVehicles: VehicleData[];
  }>;
}

// Fetch vehicles for a specific auction lane
export const fetchVehiclesForLane = async (auctionId: number, laneId: number): Promise<VehicleData[]> => {
  try {

    // Try the bidding vehicle list endpoint first
    const response = await api.get(`/bidding/vehicle-list/${laneId}`);



    // Handle different response structures
    if (response.data && Array.isArray(response.data)) {
      return response.data;
    } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
      return response.data.data;
    } else if (response.data && response.data.success && response.data.data) {
      return response.data.data;
    } else {
      console.warn('Unexpected response structure:', response.data);
      return [];
    }
  } catch (error) {
    console.error('Error fetching vehicles for lane:', error);
    console.error('Error response:', error.response);
    console.error('Error status:', error.response?.status);
    console.error('Error data:', error.response?.data);

    throw error;
  }
};

// Format price for display
const formatPrice = (price: number | string): string => {
  if (!price) return '';
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  return `AED ${numPrice.toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
};

// Helper function to safely extract string values from objects or strings
const getStringValue = (value: any): string => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && value.name) return value.name;
  if (typeof value === 'number') return value.toString();
  return '';
};

// Helper function to add placeholder image to PDF using the car placeholder asset
const addPlaceholderImage = async (pdf: jsPDF, x: number, y: number, width: number, height: number, text: string = 'No Image') => {
  try {

    // Try to load the car placeholder image from public folder
    const placeholderImg = new Image();
    placeholderImg.crossOrigin = 'anonymous';

    return new Promise((resolve) => {
      const timeout = setTimeout(() => {
        addSimplePlaceholder(pdf, x, y, width, height, text);
        resolve(false);
      }, 3000); // 3 second timeout

      placeholderImg.onload = () => {
        clearTimeout(timeout);
        try {
          // Add image with more rounded corners using clipping
          (pdf as any).saveGraphicsState();
          pdf.addImage(placeholderImg, 'PNG', x, y, width, height);
          (pdf as any).restoreGraphicsState();
          resolve(true);
        } catch (error) {
          console.error('Error adding placeholder image to PDF:', error);
          addSimplePlaceholder(pdf, x, y, width, height, text);
          resolve(false);
        }
      };

      placeholderImg.onerror = (error) => {
        clearTimeout(timeout);
        addSimplePlaceholder(pdf, x, y, width, height, text);
        resolve(false);
      };

      // Load the car placeholder image from public folder
      placeholderImg.src = '/car-placeholder.png';
    });
  } catch (error) {
    console.error('Error in addPlaceholderImage:', error);
    addSimplePlaceholder(pdf, x, y, width, height, text);
    return false;
  }
};

// Fallback simple placeholder function
const addSimplePlaceholder = (pdf: jsPDF, x: number, y: number, width: number, height: number, text: string = 'No Image') => {
  // Background rectangle - light gray like website placeholder with rounded corners
  pdf.setFillColor(240, 240, 240);
  pdf.roundedRect(x, y, width, height, 10, 10, 'F');

  // Border with rounded corners
  pdf.setDrawColor(200, 200, 200);
  pdf.roundedRect(x, y, width, height, 10, 10, 'S');

  // Simple car icon placeholder
  pdf.setFillColor(180, 180, 180);
  pdf.rect(x + width / 2 - 6, y + height / 2 - 4, 12, 6, 'F'); // Car body
  pdf.rect(x + width / 2 - 7, y + height / 2 - 2, 3, 3, 'F'); // Left wheel
  pdf.rect(x + width / 2 + 4, y + height / 2 - 2, 3, 3, 'F'); // Right wheel

  // Text - smaller and more subtle
  pdf.setTextColor(120, 120, 120);
  pdf.setFontSize(5);
  pdf.setFont('poppins', 'normal');
  pdf.text(text, x + width / 2, y + height / 2 + 6, { align: 'center' });
};

// Fallback logo placeholder function
const addLogoPlaceholder = (pdf: jsPDF, x: number, y: number, size: number) => {
  // Simple logo placeholder (circle with text)
  pdf.setFillColor(255, 255, 255);
  pdf.circle(x + size / 2, y + size / 2, size / 2, 'F');
  pdf.setTextColor(241, 90, 41); // Orange color
  pdf.setFontSize(8);
  pdf.setFont('poppins', 'bold');
  pdf.text('LOGO', x + size / 2 - 6, y + size / 2 + 1);
};

// Helper function to load logo and add to PDF
const addLogoToPDF = async (pdf: jsPDF, x: number, y: number, size: number): Promise<void> => {
  try {
    const logoImg = new Image();

    return new Promise((resolve) => {
      const timeout = setTimeout(() => {
        addEnhancedLogoPlaceholder(pdf, x, y, size);
        resolve();
      }, 3000); // 3 second timeout

      logoImg.onload = () => {
        clearTimeout(timeout);
        try {
          pdf.addImage(logoImg, 'PNG', x, y, size, size);
        } catch (error) {
          console.error('Error adding logo to PDF:', error);
          addEnhancedLogoPlaceholder(pdf, x, y, size);
        }
        resolve();
      };

      logoImg.onerror = (error) => {
        clearTimeout(timeout);
        addEnhancedLogoPlaceholder(pdf, x, y, size);
        resolve();
      };

      // Use the logo from public folder
      logoImg.src = '/Group(1).png';
    });
  } catch (error) {
    console.error('Error in addLogoToPDF:', error);
    addEnhancedLogoPlaceholder(pdf, x, y, size);
  }
};

// Enhanced logo placeholder that looks more professional
const addEnhancedLogoPlaceholder = (pdf: jsPDF, x: number, y: number, size: number) => {
  // Create a more sophisticated logo placeholder
  const centerX = x + size / 2;
  const centerY = y + size / 2;
  const radius = size / 2 - 2;

  // Outer circle with brand color
  pdf.setFillColor(241, 90, 41); // Orange
  pdf.circle(centerX, centerY, radius, 'F');

  // Inner white circle
  pdf.setFillColor(255, 255, 255);
  pdf.circle(centerX, centerY, radius - 3, 'F');

  // Add some geometric elements to make it look more like a logo
  pdf.setFillColor(241, 90, 41); // Orange again

  // Add some stylized elements (simple geometric shapes)
  const elementSize = radius * 0.3;

  // Top element
  pdf.rect(centerX - elementSize / 2, centerY - radius / 2, elementSize, elementSize, 'F');

  // Bottom element
  pdf.rect(centerX - elementSize / 2, centerY + radius / 2 - elementSize, elementSize, elementSize, 'F');

  // Left element
  pdf.rect(centerX - radius / 2, centerY - elementSize / 2, elementSize, elementSize, 'F');

  // Right element
  pdf.rect(centerX + radius / 2 - elementSize, centerY - elementSize / 2, elementSize, elementSize, 'F');

  // Center dot
  pdf.circle(centerX, centerY, elementSize / 2, 'F');
};

// Helper function to load image from public folder
const loadImageFromPublic = async (imageName: string): Promise<string | null> => {
  try {
    // Load from public folder
    const response = await fetch(`/${imageName}`);
    if (response.ok) {
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.readAsDataURL(blob);
      });
    }
    return null;
  } catch (error) {
    return null;
  }
};

// Helper function to load image and get dimensions
const loadImageWithDimensions = (src: string): Promise<HTMLImageElement | null> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = src;
  });
};

const fetchImageAsBase64 = async (url: string): Promise<string | null> => {
  try {
    // Optionally proxy cross-origin images to avoid CORS issues
    const proxy = process.env.REACT_APP_IMAGE_PROXY_URL || '';
    const isAbsolute = /^(https?:)?\/\//i.test(url);
    const targetUrl = isAbsolute && proxy
      ? `${proxy}${proxy.endsWith('/') ? '' : '/'}?url=${encodeURIComponent(url)}`
      : url;

    const response = await fetch(targetUrl, {
      mode: "cors",
      credentials: "omit",
      headers: {
        'Accept': 'image/*'
      }
    });

    if (!response.ok) {
      return null;
    }

    const blob = await response.blob();

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    return null;
  }
};

// Helper function to load image and add to PDF (CORS-safe)
// Convert base64 image to JPEG (data URL) via canvas to ensure jsPDF compatibility
const convertBase64ToJPEG = async (base64DataUrl: string): Promise<string | null> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        if (!ctx) return resolve(null);
        ctx.drawImage(img, 0, 0);
        const jpegDataUrl = canvas.toDataURL('image/jpeg', 0.92);
        resolve(jpegDataUrl);
      } catch (e) {
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = base64DataUrl;
  });
};

const addImageToPDF = async (pdf: jsPDF, imageUrl: string, x: number, y: number, width: number, height: number): Promise<boolean> => {
  try {
    const cleanUrl = imageUrl.trim();

    if (!cleanUrl || cleanUrl === 'undefined' || cleanUrl === 'null') {
      return false;
    }


    // Try to fetch as base64 (CORS-safe)
    let base64 = await fetchImageAsBase64(cleanUrl);
    if (base64) {
      // If the format is not JPEG/PNG, convert to JPEG
      const isPng = base64.startsWith('data:image/png');
      const isJpeg = base64.startsWith('data:image/jpeg');
      const isWebpOrGif = base64.startsWith('data:image/webp') || base64.startsWith('data:image/gif');

      if (!isPng && !isJpeg && isWebpOrGif) {
        const converted = await convertBase64ToJPEG(base64);
        if (converted) base64 = converted;
      }

      const format: 'PNG' | 'JPEG' = base64.startsWith('data:image/png') ? 'PNG' : 'JPEG';
      pdf.addImage(base64, format, x, y, width, height);
      return true;
    } else {
      return false;
    }

  } catch (error) {
    console.error('Error in addImageToPDF:', error);
    return false;
  }
};

const loadImageViaProxy = async (url: string): Promise<string | null> => {
  if (!url) {
    console.log("❌ [Proxy] No URL provided");
    return null;
  }

  try {
    console.log("🔵 [Proxy] Fetching image:", url);

    const response = await api.get("/products/image-proxy", {
      params: { url },
      responseType: "blob",
    });

    console.log("🟢 [Proxy] Response received", {
      status: response.status,
      size: response.data?.size,
      type: response.data?.type,
    });

    const blob = response.data;

    if (!blob || blob.size === 0) {
      console.log("❌ [Proxy] Empty blob received");
      return null;
    }

    // Convert Blob → Base64 (required for jsPDF)
    const base64 = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        console.log("✅ [Proxy] Converted to Base64");
        resolve(reader.result as string);
      };

      reader.onerror = (err) => {
        console.error("❌ [Proxy] FileReader error:", err);
        reject(err);
      };

      reader.readAsDataURL(blob);
    });

    return base64;

  } catch (error: any) {
    console.error("❌ [Proxy] Image load failed:", {
      message: error?.message,
      response: error?.response,
      url,
    });
    return null;
  }
};

const normalizeImage = async (base64: string): Promise<string> => {
  return new Promise((resolve) => {
    const img = new Image();

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx?.drawImage(img, 0, 0);

      resolve(canvas.toDataURL("image/jpeg", 1.0));
    };

    img.src = base64;
  });
};

export const generateAuctionLanePDF = async (auctionId: number, laneId: number, auctionName: string, laneName: string, auctionDate?: Date | string): Promise<void> => {
  try {

    // Fetch vehicles data
    const vehicles = await fetchVehiclesForLane(auctionId, laneId);

    if (!vehicles || vehicles.length === 0) {
      alert('No vehicles found for this auction lane');
      return;
    }

    // Create new PDF document
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 5;
    const contentWidth = pageWidth - (margin * 2);

    // Colors matching the image
    const primaryColor: [number, number, number] = [241, 90, 41]; // #F15A29 - Orange
    const darkColor: [number, number, number] = [26, 26, 26]; // #1a1a1a
    const lightGray: [number, number, number] = [200, 200, 200]; // #C8C8C8
    const white: [number, number, number] = [255, 255, 255];
    const black: [number, number, number] = [0, 0, 0];

    let currentY = margin;

    // Helper function to add new page if needed
    const checkPageBreak = (requiredHeight: number) => {
      if (currentY + requiredHeight > pageHeight - margin) {
        pdf.addPage();
        currentY = margin;
        return true;
      }
      return false;
    };

    // Helper function to add text with word wrap
    const addWrappedText = (text: string, x: number, y: number, maxWidth: number, fontSize: number = 10) => {
      pdf.setFontSize(fontSize);
      const lines = pdf.splitTextToSize(text, maxWidth);
      pdf.text(lines, x, y);
      return y + (lines.length * (fontSize * 0.4));
    };

    // Header Section - White background
    const headerY = 0;
    const headerHeight = 20; // Reduced height for more compact header

    // White header background
    pdf.setFillColor(255, 255, 255); // White color
    pdf.rect(0, headerY, pageWidth, headerHeight, 'F');

    // Logo area (center of header) - horizontally centered, vertically aligned with text
    const logoWidth = 40; // Default width for centering calculation
    const logoHeight = 15; // Default height for centering calculation
    const logoX = (pageWidth - logoWidth) / 2; // Center horizontally
    const logoY = headerY + (headerHeight - logoHeight) / 2; // Center vertically in header

    // Add logo from AWS_LOGO_URL environment variable or fallback to public folder
    try {
      // Try AWS logo URL from environment variable first
      const awsLogoUrl = process.env.REACT_APP_AWS_LOGO_URL;
      let logoUrl: string | null = null;

      if (awsLogoUrl) {
        // If AWS logo URL is provided, use it directly
        logoUrl = awsLogoUrl;
      } else {
        // Fallback to public folder
        // logoUrl = await loadImageFromPublic('Group34322224.png');
        logoUrl = await loadImageFromPublic('Group(2).png');
      }

      let logoImage: HTMLImageElement | null = null;
      let logoBase64: string | null = null;

      if (logoUrl) {
        // If we have an AWS URL (full URL), fetch it as base64 first
        if (awsLogoUrl && logoUrl.startsWith('https') || logoUrl.startsWith('http')) {
          console.log('Trying fetchImageAsBase64 for AWS logo URL:', logoUrl);
          logoBase64 = await fetchImageAsBase64(logoUrl);
          if (logoBase64) {
            console.log('Logo base64 loaded successfully');
            logoImage = await loadImageWithDimensions(logoBase64);
            console.log('Logo image loaded successfully');
          }
        } else {
          // If it's a local/public folder path, use loadImageWithDimensions
          logoImage = await loadImageWithDimensions(logoUrl);
        }
      }

      if (logoImage) {
        // Use actual image dimensions to avoid blurriness
        const actualLogoWidth = logoImage.width * 0.264583 * 0.5 ; // Convert pixels to mm (1px = 0.264583mm at 96 DPI)
        const actualLogoHeight = logoImage.height * 0.264583 * 0.5;
        // Recalculate center position with actual dimensions, vertically aligned
        const centeredLogoX = (pageWidth - actualLogoWidth) / 2;
        const centeredLogoY = headerY + (headerHeight - actualLogoHeight) / 2;

        // Use the appropriate source (base64 for AWS URL, original for local)
        if (logoBase64) {
          await addImageToPDF(pdf, logoBase64, centeredLogoX, centeredLogoY, actualLogoWidth, actualLogoHeight);
        } else {
          await addImageToPDF(pdf, logoUrl!, centeredLogoX, centeredLogoY, actualLogoWidth, actualLogoHeight);
        }
      }

      // If image doesn't load, show text fallback
      if (!logoImage) {
        const fallbackWidth = 40; // Default width for fallback
        const fallbackHeight = 15; // Default height for fallback
        pdf.setFillColor(240, 240, 240);
        pdf.rect(logoX, logoY, fallbackWidth, fallbackHeight, 'F');
        pdf.setTextColor(black[0], black[1], black[2]);
        pdf.setFontSize(8);
        pdf.setFont('poppins', 'bold');
        pdf.text('KHAT AL JAZEERA', logoX + 1, logoY + 5);
        pdf.text('CARS AUCTIONS LLC', logoX + 1, logoY + 8);
      }
    } catch (error) {
      console.error('Error loading logo:', error);
      // Fallback to text if image loading fails
      const fallbackWidth = 40; // Default width for fallback
      const fallbackHeight = 15; // Default height for fallback
    pdf.setFillColor(240, 240, 240);
      pdf.rect(logoX, logoY, fallbackWidth, fallbackHeight, 'F');
      pdf.setTextColor(black[0], black[1], black[2]);
      pdf.setFontSize(8);
      pdf.setFont('poppins', 'bold');
      pdf.text('KHAT AL JAZEERA', logoX + 1, logoY + 5);
      pdf.text('CARS AUCTIONS LLC', logoX + 1, logoY + 8);
    }

    // Auction details - Two columns layout (left and right) INSIDE header area
    const leftColX = margin + 2; // Left column at left edge
    const rightColX = pageWidth - margin - 60; // Right column near right edge
    const detailsY = headerY + (headerHeight - 8) / 2 + 4; // Center vertically in header, moved down 2mm

    // Left column - Labels in darker orange
    pdf.setTextColor(200, 100, 50); // Darker orange for labels
    pdf.setFontSize(8);
    pdf.setFont('poppins', 'bold');
    pdf.text('Auction Name:', leftColX, detailsY);
    pdf.text('Auction Lane:', leftColX, detailsY + 3);

    // Left column - Values in black
    pdf.setTextColor(black[0], black[1], black[2]);
    pdf.setFont('poppins', 'normal');
    pdf.text(auctionName, leftColX + 20, detailsY);
    pdf.text(laneName, leftColX + 20, detailsY + 3);

    // Right column - Labels in darker orange
    pdf.setTextColor(200, 100, 50); // Darker orange for labels
    pdf.setFont('poppins', 'bold');
    pdf.text('Location:', rightColX, detailsY);
    pdf.text('Date/Time:', rightColX, detailsY + 3);

    // Right column - Values in black
    pdf.setTextColor(black[0], black[1], black[2]);
    pdf.setFont('poppins', 'normal');

    // Format auction date - Format: (12,Friday 2025)
    let auctionDateTimeText = '';
    if (auctionDate) {
      const date = new Date(auctionDate);
      if (!isNaN(date.getTime())) {
        const day = date.getDate();
        const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
        const year = date.getFullYear();
        auctionDateTimeText = `(${day},${dayName} ${year})`;
      } else {
        auctionDateTimeText = '';
      }
    } else {
      auctionDateTimeText = '';
    }
    pdf.text('Khat Al Jazeera Cars Auction, Al Sajaa', rightColX + 20, detailsY);
    pdf.text(auctionDateTimeText, rightColX + 20, detailsY + 3);

    // Orange separator line - positioned exactly at the bottom of header, matching header width exactly
    pdf.setDrawColor(primaryColor[0], primaryColor[1], primaryColor[2]);
    pdf.setLineWidth(0.5);
    pdf.line(0, headerY + headerHeight, pageWidth, headerY + headerHeight);

    currentY = headerY + headerHeight + 10; // Space after header

    // Catalog title section
    pdf.setTextColor(60, 60, 60); // Dark gray color
    pdf.setFontSize(14);
    pdf.setFont('poppins', 'bold');
    pdf.text(`${laneName} Vehicle Catalog (${vehicles.length} Listings)`, margin, currentY );

    currentY += 4; // Space after title

    // Orange separator line under title
    pdf.setDrawColor(primaryColor[0], primaryColor[1], primaryColor[2]);
    pdf.setLineWidth(0.01);
    pdf.line(margin, currentY, pageWidth - margin, currentY);

    currentY += 5; // Space after separator

    // Main table header - Dark gray background like in the image
    pdf.setFillColor(60, 60, 60); // Dark gray header
    pdf.roundedRect(margin, currentY, contentWidth, 8, 2, 2, 'F');

    // Table header text - White text on dark background
    pdf.setTextColor(white[0], white[1], white[2]);
    pdf.setFontSize(8);
    pdf.setFont('poppins', 'bold');

    // Column headers with increased spacing between first three columns
    const runColX = margin + 2;
    const imageColX = margin + 15; // increased gap after RUN#
    const vehicleColX = margin + 35; // increased gap after IMAGE
    const milesColX = margin + 95;
    const fuelCylColX = margin + 115;
    // Right-edge columns: MARKET VALUE (left of) and STARTING BID (far right)
    const startingBidColX = margin + contentWidth - 2; // right edge of table
    const marketValueColX = startingBidColX - 35;      // space left of starting bid

    // Header labels - adjusted font size to fit properly
    pdf.setFontSize(8);
    pdf.text('RUN#', runColX, currentY + 6);
    pdf.text('IMAGE', imageColX, currentY + 6);
    pdf.text('VEHICLE DETAILS', vehicleColX, currentY + 6);
    pdf.text('MILES', milesColX, currentY + 6, { align: 'right' });
    pdf.text('FUEL/CYL', fuelCylColX, currentY + 6);
    pdf.text('MARKET VALUE', marketValueColX, currentY + 6, { align: 'right' });
    pdf.text('STARTING BID', startingBidColX, currentY + 6, { align: 'right' });

    currentY += 8; // Space after header

    // Vehicle rows - Matching the exact layout from the image
    for (let index = 0; index < vehicles.length; index++) {
      const vehicle = vehicles[index];

      // Check if we need a new page
      checkPageBreak(20);

      // Row background (white for all rows like in the image)
      pdf.setFillColor(white[0], white[1], white[2]);
      pdf.roundedRect(margin, currentY, contentWidth, 18, 2, 2, 'F');

      // Run number - reduced size to match reference, vertically centered
      pdf.setTextColor(black[0], black[1], black[2]);
      pdf.setFontSize(8);
      pdf.setFont('poppins', 'bold');
      pdf.text(`${index + 1}`, runColX, currentY + 9, { align: 'left' }); // Center in 18mm row

      // Vehicle image - larger size to match reference
      const imageX = imageColX;
      const imageY = currentY + 3;
      const imageWidth = 15;
      const imageHeight = 12;

       // Add vehicle image if available
       let firstImage = '';
      if (vehicle.images && vehicle.images.length > 0) {
        const firstImageData = vehicle.images[0];
        if (typeof firstImageData === 'string') {
          firstImage = firstImageData;
        } else if (firstImageData && firstImageData.imageUrl) {
          firstImage = firstImageData.imageUrl;
        }
      }

      // Try to load actual image first
      let imageLoaded = false;

if (firstImage) {
  try {
    console.log("🔵 Processing vehicle image:", firstImage);

    // ✅ STEP 1: Load via proxy (BEST METHOD)
    const base64Image = await loadImageViaProxy(firstImage);

    if (base64Image) {
      try {
      const normalized = await normalizeImage(base64Image);
      console.log("IMAGE TYPE:", base64Image.substring(0, 30));
pdf.addImage(normalized, "JPEG", imageX, imageY, imageWidth, imageHeight);
        imageLoaded = true;
        console.log("✅ Image added via proxy");
      } catch (pdfError) {
        console.error("❌ Failed to add proxy image to PDF:", pdfError);
      }
    }

    // ✅ STEP 2: Fallback → direct URL
    if (!imageLoaded) {
      console.log("⚠️ Falling back to direct image load");

      const img = new Image();
      img.crossOrigin = "anonymous";

      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
          reject(new Error("Image timeout"));
        }, 8000);

        img.onload = () => {
          clearTimeout(timeout);
          try {
            pdf.addImage(img, "JPEG", imageX, imageY, imageWidth, imageHeight);
            imageLoaded = true;
            console.log("✅ Direct image added");
            resolve(true);
          } catch (err) {
            reject(err);
          }
        };

        img.onerror = (err) => {
          clearTimeout(timeout);
          reject(err);
        };

        img.src = firstImage;
      });
    }

  } catch (error) {
    console.error("❌ Image processing failed:", error);
  }
}

 
      // Show placeholder only if image failed to load
      if (!imageLoaded) {
        await addPlaceholderImage(pdf, imageX, imageY, imageWidth, imageHeight, 'No Image');
      }

      // Vehicle details - 3 lines like in reference
      const textX = vehicleColX;
      const textY = currentY + 5;

      // Line 1: Vehicle name (Year Make Model) - Reduced size to match reference
      pdf.setTextColor(black[0], black[1], black[2]);
      pdf.setFontSize(7);
      pdf.setFont('poppins', 'bold');
      const makeName = typeof vehicle.Make === 'string' ? vehicle.Make : vehicle.Make?.name || 
                      (typeof vehicle.make === 'string' ? vehicle.make : vehicle.make?.name) || 
                      (typeof vehicle.MakeModel === 'object' && vehicle.MakeModel?.make?.name) || '';
      const modelName = typeof vehicle.model === 'string' ? vehicle.model : vehicle.model?.name || 
                       (typeof vehicle.MakeModel === 'string' ? vehicle.MakeModel : vehicle.MakeModel?.name) || '';
      const vehicleName = vehicle.name || `${vehicle.year || ''} ${makeName} ${modelName}`.trim();
      pdf.text(vehicleName, textX, textY);

      // Line 2: Lot number - Reduced size
      pdf.setTextColor(black[0], black[1], black[2]);
      pdf.setFontSize(6);
      pdf.setFont('poppins', 'normal');
      const lotNumber = vehicle.lotNumber || vehicle.lot || '';
      if (lotNumber) {
        pdf.text(`Lot ${lotNumber}`, textX, textY + 3);
      }

      // Line 3: Engine and Highlights - Reduced size
      const engineSize = (typeof vehicle.engine === 'string' ? vehicle.engine : vehicle.engine?.name) || 
                        vehicle.engineType || '';
      const highlightData = vehicle.Highlight;
      const highlightValue = highlightData?.name || '';
      const engineHighlights = `Eng: ${engineSize} | Highlights: ${highlightValue || '-'}`;
      pdf.text(engineHighlights, textX, textY + 6);

      // Miles - Right aligned, reduced font size, vertically centered
      pdf.setTextColor(black[0], black[1], black[2]);
      pdf.setFontSize(6);
      pdf.setFont('poppins', 'normal');
      const mileage = vehicle.mileage || 0;
      pdf.text(`${mileage.toLocaleString()}`, milesColX, currentY + 9, { align: 'right' }); // Center in 18mm row

      // Fuel/Cyl - Combined column, reduced font size, vertically centered
      const fuelType = (typeof vehicle.fuelType === 'string' ? vehicle.fuelType : vehicle.fuelType?.name) || 
                      vehicle.fuelTypeName || '';
      const cylinders = vehicle.cylinders || 
                       (typeof vehicle.cylinder === 'number' ? vehicle.cylinder : vehicle.cylinder?.name) || '';
      const fuelCylText = `${fuelType} / ${cylinders} Cyl`;
      pdf.setFontSize(6);
      pdf.text(fuelCylText, fuelCylColX, currentY + 9); // Center in 18mm row

      // Starting Bid - Bold, black, right-aligned, reduced font size, vertically centered
      pdf.setTextColor(black[0], black[1], black[2]);
      pdf.setFontSize(7);
      pdf.setFont('poppins', 'bold');
      const startingBid = vehicle.startingBid || 0;
      pdf.text(formatPrice(startingBid), startingBidColX, currentY + 9, { align: 'right' }); // Center in 18mm row

      // Market Value - Bold, orange, right-aligned, reduced font size, vertically centered
      pdf.setTextColor(255, 152, 0); // Orange color like in reference
      pdf.setFontSize(7);
      pdf.setFont('poppins', 'bold');
      const marketValue = vehicle.marketValue || vehicle.marketPrice || 0;
      pdf.text(formatPrice(marketValue), marketValueColX, currentY + 9, { align: 'right' }); // Center in 18mm row

      currentY += 18; // Increased row height to match reference
    }

    // Footer
    const totalPages = (pdf as any).getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      pdf.setPage(i);
      pdf.setFontSize(8);
      pdf.setTextColor(lightGray[0], lightGray[1], lightGray[2]);
      pdf.text(`Page ${i} of ${totalPages}`, pageWidth - margin - 20, pageHeight - 10);
    }

    // Generate filename
    const fileName = `${auctionName.replace(/[^a-zA-Z0-9]/g, '_')}_${laneName.replace(/[^a-zA-Z0-9]/g, '_')}_Vehicles.pdf`;


    // Save the PDF
    try {
      pdf.save(fileName);
    } catch (saveError) {
      console.error('Error saving PDF:', saveError);
      throw new Error('Failed to save PDF file');
    }

  } catch (error) {
    console.error('Error generating PDF:', error);
    console.error('Error details:', {
      message: error.message,
      stack: error.stack,
      name: error.name
    });
    alert(`Failed to generate PDF: ${error.message || ''}. Please check the console for details.`);
  }
};

// Generate PDF for auction lane vehicles
// export const generateAuctionLanePDF = async (auctionId: number, laneId: number, auctionName: string, laneName: string, auctionDate?: Date | string): Promise<void> => {
//   try {

//     // Fetch vehicles data
//     const vehicles = await fetchVehiclesForLane(auctionId, laneId);

//     if (!vehicles || vehicles.length === 0) {
//       alert('No vehicles found for this auction lane');
//       return;
//     }

//     // Create new PDF document
//     const pdf = new jsPDF('p', 'mm', 'a4');
//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();
//     const margin = 5;
//     const contentWidth = pageWidth - (margin * 2);

//     // Colors matching the image
//     const primaryColor: [number, number, number] = [241, 90, 41]; // #F15A29 - Orange
//     const darkColor: [number, number, number] = [26, 26, 26]; // #1a1a1a
//     const lightGray: [number, number, number] = [200, 200, 200]; // #C8C8C8
//     const white: [number, number, number] = [255, 255, 255];
//     const black: [number, number, number] = [0, 0, 0];

//     let currentY = margin;

//     // Helper function to add new page if needed
//     const checkPageBreak = (requiredHeight: number) => {
//       if (currentY + requiredHeight > pageHeight - margin) {
//         pdf.addPage();
//         currentY = margin;
//         return true;
//       }
//       return false;
//     };

//     // Helper function to add text with word wrap
//     const addWrappedText = (text: string, x: number, y: number, maxWidth: number, fontSize: number = 10) => {
//       pdf.setFontSize(fontSize);
//       const lines = pdf.splitTextToSize(text, maxWidth);
//       pdf.text(lines, x, y);
//       return y + (lines.length * (fontSize * 0.4));
//     };

//     // Header Section - White background
//     const headerY = 0;
//     const headerHeight = 20; // Reduced height for more compact header

//     // White header background
//     pdf.setFillColor(255, 255, 255); // White color
//     pdf.rect(0, headerY, pageWidth, headerHeight, 'F');

//     // Logo area (center of header) - horizontally centered, vertically aligned with text
//     const logoWidth = 40; // Default width for centering calculation
//     const logoHeight = 15; // Default height for centering calculation
//     const logoX = (pageWidth - logoWidth) / 2; // Center horizontally
//     const logoY = headerY + (headerHeight - logoHeight) / 2; // Center vertically in header

//     // Add logo from AWS_LOGO_URL environment variable or fallback to public folder
//     try {
//       // Try AWS logo URL from environment variable first
//       const awsLogoUrl = process.env.REACT_APP_AWS_LOGO_URL;
//       let logoUrl: string | null = null;

//       if (awsLogoUrl) {
//         // If AWS logo URL is provided, use it directly
//         logoUrl = awsLogoUrl;
//       } else {
//         // Fallback to public folder
//         // logoUrl = await loadImageFromPublic('Group34322224.png');
//         logoUrl = await loadImageFromPublic('Group(2).png');
//       }

//       let logoImage: HTMLImageElement | null = null;
//       let logoBase64: string | null = null;

//       if (logoUrl) {
//         // If we have an AWS URL (full URL), fetch it as base64 first
//         if (awsLogoUrl && logoUrl.startsWith('https') || logoUrl.startsWith('http')) {
//           console.log('Trying fetchImageAsBase64 for AWS logo URL:', logoUrl);
//           logoBase64 = await fetchImageAsBase64(logoUrl);
//           if (logoBase64) {
//             console.log('Logo base64 loaded successfully');
//             logoImage = await loadImageWithDimensions(logoBase64);
//             console.log('Logo image loaded successfully');
//           }
//         } else {
//           // If it's a local/public folder path, use loadImageWithDimensions
//           logoImage = await loadImageWithDimensions(logoUrl);
//         }
//       }

//       if (logoImage) {
//         // Use actual image dimensions to avoid blurriness
//         const actualLogoWidth = logoImage.width * 0.264583 * 0.5 ; // Convert pixels to mm (1px = 0.264583mm at 96 DPI)
//         const actualLogoHeight = logoImage.height * 0.264583 * 0.5;
//         // Recalculate center position with actual dimensions, vertically aligned
//         const centeredLogoX = (pageWidth - actualLogoWidth) / 2;
//         const centeredLogoY = headerY + (headerHeight - actualLogoHeight) / 2;

//         // Use the appropriate source (base64 for AWS URL, original for local)
//         if (logoBase64) {
//           await addImageToPDF(pdf, logoBase64, centeredLogoX, centeredLogoY, actualLogoWidth, actualLogoHeight);
//         } else {
//           await addImageToPDF(pdf, logoUrl!, centeredLogoX, centeredLogoY, actualLogoWidth, actualLogoHeight);
//         }
//       }

//       // If image doesn't load, show text fallback
//       if (!logoImage) {
//         const fallbackWidth = 40; // Default width for fallback
//         const fallbackHeight = 15; // Default height for fallback
//         pdf.setFillColor(240, 240, 240);
//         pdf.rect(logoX, logoY, fallbackWidth, fallbackHeight, 'F');
//         pdf.setTextColor(black[0], black[1], black[2]);
//         pdf.setFontSize(8);
//         pdf.setFont('poppins', 'bold');
//         pdf.text('KHAT AL JAZEERA', logoX + 1, logoY + 5);
//         pdf.text('CARS AUCTIONS LLC', logoX + 1, logoY + 8);
//       }
//     } catch (error) {
//       console.error('Error loading logo:', error);
//       // Fallback to text if image loading fails
//       const fallbackWidth = 40; // Default width for fallback
//       const fallbackHeight = 15; // Default height for fallback
//     pdf.setFillColor(240, 240, 240);
//       pdf.rect(logoX, logoY, fallbackWidth, fallbackHeight, 'F');
//       pdf.setTextColor(black[0], black[1], black[2]);
//       pdf.setFontSize(8);
//       pdf.setFont('poppins', 'bold');
//       pdf.text('KHAT AL JAZEERA', logoX + 1, logoY + 5);
//       pdf.text('CARS AUCTIONS LLC', logoX + 1, logoY + 8);
//     }

//     // Auction details - Two columns layout (left and right) INSIDE header area
//     const leftColX = margin + 2; // Left column at left edge
//     const rightColX = pageWidth - margin - 60; // Right column near right edge
//     const detailsY = headerY + (headerHeight - 8) / 2 + 4; // Center vertically in header, moved down 2mm

//     // Left column - Labels in darker orange
//     pdf.setTextColor(200, 100, 50); // Darker orange for labels
//     pdf.setFontSize(8);
//     pdf.setFont('poppins', 'bold');
//     pdf.text('Auction Name:', leftColX, detailsY);
//     pdf.text('Auction Lane:', leftColX, detailsY + 3);

//     // Left column - Values in black
//     pdf.setTextColor(black[0], black[1], black[2]);
//     pdf.setFont('poppins', 'normal');
//     pdf.text(auctionName, leftColX + 20, detailsY);
//     pdf.text(laneName, leftColX + 20, detailsY + 3);

//     // Right column - Labels in darker orange
//     pdf.setTextColor(200, 100, 50); // Darker orange for labels
//     pdf.setFont('poppins', 'bold');
//     pdf.text('Location:', rightColX, detailsY);
//     pdf.text('Date/Time:', rightColX, detailsY + 3);

//     // Right column - Values in black
//     pdf.setTextColor(black[0], black[1], black[2]);
//     pdf.setFont('poppins', 'normal');

//     // Format auction date - Format: (12,Friday 2025)
//     let auctionDateTimeText = '';
//     if (auctionDate) {
//       const date = new Date(auctionDate);
//       if (!isNaN(date.getTime())) {
//         const day = date.getDate();
//         const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
//         const year = date.getFullYear();
//         auctionDateTimeText = `(${day},${dayName} ${year})`;
//       } else {
//         auctionDateTimeText = '';
//       }
//     } else {
//       auctionDateTimeText = '';
//     }
//     pdf.text('Khat Al Jazeera Cars Auction, Al Sajaa', rightColX + 20, detailsY);
//     pdf.text(auctionDateTimeText, rightColX + 20, detailsY + 3);

//     // Orange separator line - positioned exactly at the bottom of header, matching header width exactly
//     pdf.setDrawColor(primaryColor[0], primaryColor[1], primaryColor[2]);
//     pdf.setLineWidth(0.5);
//     pdf.line(0, headerY + headerHeight, pageWidth, headerY + headerHeight);

//     currentY = headerY + headerHeight + 10; // Space after header

//     // Catalog title section
//     pdf.setTextColor(60, 60, 60); // Dark gray color
//     pdf.setFontSize(14);
//     pdf.setFont('poppins', 'bold');
//     pdf.text(`${laneName} Vehicle Catalog (${vehicles.length} Listings)`, margin, currentY );

//     currentY += 4; // Space after title

//     // Orange separator line under title
//     pdf.setDrawColor(primaryColor[0], primaryColor[1], primaryColor[2]);
//     pdf.setLineWidth(0.01);
//     pdf.line(margin, currentY, pageWidth - margin, currentY);

//     currentY += 5; // Space after separator

//     // Main table header - Dark gray background like in the image
//     pdf.setFillColor(60, 60, 60); // Dark gray header
//     pdf.roundedRect(margin, currentY, contentWidth, 8, 2, 2, 'F');

//     // Table header text - White text on dark background
//     pdf.setTextColor(white[0], white[1], white[2]);
//     pdf.setFontSize(8);
//     pdf.setFont('poppins', 'bold');

//     // Column headers with increased spacing between first three columns
//     const runColX = margin + 2;
//     const imageColX = margin + 15; // increased gap after RUN#
//     const vehicleColX = margin + 35; // increased gap after IMAGE
//     const milesColX = margin + 95;
//     const fuelCylColX = margin + 115;
//     // Right-edge columns: MARKET VALUE (left of) and STARTING BID (far right)
//     const startingBidColX = margin + contentWidth - 2; // right edge of table
//     const marketValueColX = startingBidColX - 35;      // space left of starting bid

//     // Header labels - adjusted font size to fit properly
//     pdf.setFontSize(8);
//     pdf.text('RUN#', runColX, currentY + 6);
//     pdf.text('IMAGE', imageColX, currentY + 6);
//     pdf.text('VEHICLE DETAILS', vehicleColX, currentY + 6);
//     pdf.text('MILES', milesColX, currentY + 6, { align: 'right' });
//     pdf.text('FUEL/CYL', fuelCylColX, currentY + 6);
//     pdf.text('MARKET VALUE', marketValueColX, currentY + 6, { align: 'right' });
//     pdf.text('STARTING BID', startingBidColX, currentY + 6, { align: 'right' });

//     currentY += 8; // Space after header

//     // Vehicle rows - Matching the exact layout from the image
//     for (let index = 0; index < vehicles.length; index++) {
//       const vehicle = vehicles[index];

//       // Check if we need a new page
//       checkPageBreak(20);

//       // Row background (white for all rows like in the image)
//       pdf.setFillColor(white[0], white[1], white[2]);
//       pdf.roundedRect(margin, currentY, contentWidth, 18, 2, 2, 'F');

//       // Run number - reduced size to match reference, vertically centered
//       pdf.setTextColor(black[0], black[1], black[2]);
//       pdf.setFontSize(8);
//       pdf.setFont('poppins', 'bold');
//       pdf.text(`${index + 1}`, runColX, currentY + 9, { align: 'left' }); // Center in 18mm row

//       // Vehicle image - larger size to match reference
//       const imageX = imageColX;
//       const imageY = currentY + 3;
//       const imageWidth = 15;
//       const imageHeight = 12;

//        // Add vehicle image if available
//        let firstImage = '';
//       if (vehicle.images && vehicle.images.length > 0) {
//         const firstImageData = vehicle.images[0];
//         if (typeof firstImageData === 'string') {
//           firstImage = firstImageData;
//         } else if (firstImageData && firstImageData.imageUrl) {
//           firstImage = firstImageData.imageUrl;
//         }
//       }

//       // Try to load actual image first
//       let imageLoaded = false;
//        if (firstImage) {
//          try {

//           // Try the CORS-safe method first
//           imageLoaded = await addImageToPDF(pdf, firstImage, imageX, imageY, imageWidth, imageHeight);

//           // If that failed, try direct image loading
//           if (!imageLoaded) {
//             try {
//               const img = new Image();
//               img.crossOrigin = 'anonymous';

//               await new Promise((resolve, reject) => {
//                 const timeout = setTimeout(() => {
//                   reject(new Error('Image load timeout'));
//                 }, 10000);

//                 img.onload = () => {
//                   clearTimeout(timeout);
//                   try {
//                     pdf.addImage(img, 'JPEG', imageX, imageY, imageWidth, imageHeight);
//                     imageLoaded = true;
//                     resolve(true);
//                   } catch (error) {
//                     reject(error);
//                   }
//                 };

//                 img.onerror = (error) => {
//                   clearTimeout(timeout);
//                   reject(error);
//                 };

//                 img.src = firstImage;
//               });
//             } catch (directError) {
//             }
//           }

//          } catch (error) {
//            console.error('Error adding vehicle image to PDF:', error);
//           imageLoaded = false;
//         }
//       }

//       // Show placeholder only if image failed to load
//       if (!imageLoaded) {
//         await addPlaceholderImage(pdf, imageX, imageY, imageWidth, imageHeight, 'No Image');
//       }

//       // Vehicle details - 3 lines like in reference
//       const textX = vehicleColX;
//       const textY = currentY + 5;

//       // Line 1: Vehicle name (Year Make Model) - Reduced size to match reference
//       pdf.setTextColor(black[0], black[1], black[2]);
//       pdf.setFontSize(7);
//       pdf.setFont('poppins', 'bold');
//       const makeName = typeof vehicle.Make === 'string' ? vehicle.Make : vehicle.Make?.name || 
//                       (typeof vehicle.make === 'string' ? vehicle.make : vehicle.make?.name) || 
//                       (typeof vehicle.MakeModel === 'object' && vehicle.MakeModel?.make?.name) || '';
//       const modelName = typeof vehicle.model === 'string' ? vehicle.model : vehicle.model?.name || 
//                        (typeof vehicle.MakeModel === 'string' ? vehicle.MakeModel : vehicle.MakeModel?.name) || '';
//       const vehicleName = vehicle.name || `${vehicle.year || ''} ${makeName} ${modelName}`.trim();
//       pdf.text(vehicleName, textX, textY);

//       // Line 2: Lot number - Reduced size
//       pdf.setTextColor(black[0], black[1], black[2]);
//       pdf.setFontSize(6);
//       pdf.setFont('poppins', 'normal');
//       const lotNumber = vehicle.lotNumber || vehicle.lot || '';
//       if (lotNumber) {
//         pdf.text(`Lot ${lotNumber}`, textX, textY + 3);
//       }

//       // Line 3: Engine and Highlights - Reduced size
//       const engineSize = (typeof vehicle.engine === 'string' ? vehicle.engine : vehicle.engine?.name) || 
//                         vehicle.engineType || '';
//       const highlightData = vehicle.Highlight;
//       const highlightValue = highlightData?.name || '';
//       const engineHighlights = `Eng: ${engineSize} | Highlights: ${highlightValue || '-'}`;
//       pdf.text(engineHighlights, textX, textY + 6);

//       // Miles - Right aligned, reduced font size, vertically centered
//       pdf.setTextColor(black[0], black[1], black[2]);
//       pdf.setFontSize(6);
//       pdf.setFont('poppins', 'normal');
//       const mileage = vehicle.mileage || 0;
//       pdf.text(`${mileage.toLocaleString()}`, milesColX, currentY + 9, { align: 'right' }); // Center in 18mm row

//       // Fuel/Cyl - Combined column, reduced font size, vertically centered
//       const fuelType = (typeof vehicle.fuelType === 'string' ? vehicle.fuelType : vehicle.fuelType?.name) || 
//                       vehicle.fuelTypeName || '';
//       const cylinders = vehicle.cylinders || 
//                        (typeof vehicle.cylinder === 'number' ? vehicle.cylinder : vehicle.cylinder?.name) || '';
//       const fuelCylText = `${fuelType} / ${cylinders} Cyl`;
//       pdf.setFontSize(6);
//       pdf.text(fuelCylText, fuelCylColX, currentY + 9); // Center in 18mm row

//       // Starting Bid - Bold, black, right-aligned, reduced font size, vertically centered
//       pdf.setTextColor(black[0], black[1], black[2]);
//       pdf.setFontSize(7);
//       pdf.setFont('poppins', 'bold');
//       const startingBid = vehicle.startingBid || 0;
//       pdf.text(formatPrice(startingBid), startingBidColX, currentY + 9, { align: 'right' }); // Center in 18mm row

//       // Market Value - Bold, orange, right-aligned, reduced font size, vertically centered
//       pdf.setTextColor(255, 152, 0); // Orange color like in reference
//       pdf.setFontSize(7);
//       pdf.setFont('poppins', 'bold');
//       const marketValue = vehicle.marketValue || vehicle.marketPrice || 0;
//       pdf.text(formatPrice(marketValue), marketValueColX, currentY + 9, { align: 'right' }); // Center in 18mm row

//       currentY += 18; // Increased row height to match reference
//     }

//     // Footer
//     const totalPages = (pdf as any).getNumberOfPages();
//     for (let i = 1; i <= totalPages; i++) {
//       pdf.setPage(i);
//       pdf.setFontSize(8);
//       pdf.setTextColor(lightGray[0], lightGray[1], lightGray[2]);
//       pdf.text(`Page ${i} of ${totalPages}`, pageWidth - margin - 20, pageHeight - 10);
//     }

//     // Generate filename
//     const fileName = `${auctionName.replace(/[^a-zA-Z0-9]/g, '_')}_${laneName.replace(/[^a-zA-Z0-9]/g, '_')}_Vehicles.pdf`;


//     // Save the PDF
//     try {
//       pdf.save(fileName);
//     } catch (saveError) {
//       console.error('Error saving PDF:', saveError);
//       throw new Error('Failed to save PDF file');
//     }

//   } catch (error) {
//     console.error('Error generating PDF:', error);
//     console.error('Error details:', {
//       message: error.message,
//       stack: error.stack,
//       name: error.name
//     });
//     alert(`Failed to generate PDF: ${error.message || ''}. Please check the console for details.`);
//   }
// };

// Alternative method using HTML to PDF conversion (if needed)
export const generateAuctionLanePDFFromHTML = async (auctionId: number, laneId: number, auctionName: string, laneName: string, auctionDate?: Date | string): Promise<void> => {
  try {
    // This method could be used if we want to generate PDF from HTML template
    // For now, we'll use the direct PDF generation method above
    await generateAuctionLanePDF(auctionId, laneId, auctionName, laneName, auctionDate?.toString());
  } catch (error) {
    console.error('Error generating PDF from HTML:', error);
    alert('Failed to generate PDF. Please try again.');
  }
};
